import { useCallback } from "react";
import { makeVar, ReactiveVar, useReactiveVar } from "@apollo/client";

export interface resetPasswordInputType {
  email?: string;
  code?: string;
  newPassword?: string;
}

const resetPasswordInitialValue: resetPasswordInputType = {
  email: "",
  code: "",
  newPassword: "",
};

// The return value of makeVar is a function that you call to read or modify your reactive variable's value.
export const resetPasswordVar: ReactiveVar<resetPasswordInputType> =
  makeVar<resetPasswordInputType>(resetPasswordInitialValue);

export const clearResetPassword = () => {
  resetPasswordVar(resetPasswordInitialValue);
};

export const useResetPasswordValue = () => {
  const resetPasswordValue = useReactiveVar(resetPasswordVar);

  const updateResetPassword = useCallback(
    (data: resetPasswordInputType) => {
      resetPasswordVar({
        ...resetPasswordValue,
        ...data,
      });
    },
    [resetPasswordValue]
  );

  return {
    resetPasswordValue,
    updateResetPassword,
  };
};
